import { FC } from "react";
import { Button } from "../../../components/ui-kit/RoundButton";

interface PageButtonProps {
    title: string;
    href: string;
    target?: string
}
export const PageButton: FC<PageButtonProps> = ({
    title,
    href,
    target
}) => {
    return (
        <>
            <div className="hidden sm:block">
                <Button title={title} href={href} target={target} />
            </div>
            <div className="sm:hidden">
                <Button title={title} href={href} target={target} size="xs" />
            </div>
        </>
    )
}
